export const addToCartPanelTypesData = {
	'add-to-cart': {
		url: '/ajax/cart/checkandaddtocart',
		pubSubEvent: 'addToCart',
		formIdPrefix: 'addToCart',
	},
	'premium-gift-add-to-cart': {
		url: '/ajax/premiumshop/gift/add',
		pubSubEvent: 'premiumGiftAddToCart',
		formIdPrefix: 'premiumGift_addToCart',
	},
};

const addToCartPanelTypeData = (addToCartType, kindOfData) => {
	if (!addToCartType || !kindOfData) return;

	const data = addToCartPanelTypesData?.[addToCartType]?.[kindOfData];

	return data;
};

export default addToCartPanelTypeData;
